import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { DocuSignRequest } from '../../../../docusign/models/docusign-models';
import { LayDcPlanAdoptionContentModel, LayDcPlanFormModel } from '../../models/plan-adoption-form-models';
import { GetAmendRsvpFormContentModel, GetRsvpPreviousValues } from '../plan-amend-helper';
import { RsvpIndemnifyWizard } from './rsvp-indemnify-wizard';


export class RsvpAmendIndemnifyWizard extends RsvpIndemnifyWizard {

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();
        const amendCommonFormContentModel = GetAmendRsvpFormContentModel(content, institutionSettings);

        return {
            ...amendCommonFormContentModel,
            gpsType: GpsType.RsvpAmendIndemnify,
            pageTitle: institutionSettings?.adoptLayRSVPIndemnifyTitle,
            PageDescription: '',
            submitLabel: institutionSettings?.adoptLayRSVPIndemnifySubmitLabel,
            cancelLabel: institutionSettings?.adoptLayRSVPIndemnifyCancelLabel,
            indemnifyDocuSignFinishText: institutionSettings?.amendRSVPIndemnifyDocuSignFinishText,
            indemnifyDocuSignRejectText: institutionSettings?.amendRSVPIndemnifyDocuSignRejectText,
            indemnifyWarningTitle: institutionSettings?.amendRSVPIndemnifyWarningTitle,
            indemnifyWarningInstruction1: institutionSettings?.amendRSVPIndemnifyWarningInstruction1,
            indemnifyWarningInstruction2: institutionSettings?.amendRSVPIndemnifyWarningInstruction2,
            indemnifyDocuSignTemplateId: institutionSettings?.amendRSVPIndemnifyDocuSignTemplateId,
            indemnifyDocuSignSubject: institutionSettings?.amendRSVPIndemnifyDocuSignSubject,
            indemnifySuccessMessage: institutionSettings?.amendRSVPIndemnifySuccessMessage,
            indemnifySkippedMessage: institutionSettings?.amendRSVPIndemnifySkippedMessage,            
        };
    }

    prepareIndemnificationDocuSignRequest(): DocuSignRequest {

        const defaultRequest = super.prepareIndemnificationDocuSignRequest();

        // TODO: Map the custom text fields.

        const docuSignRequest: DocuSignRequest = {
            ...defaultRequest,
        };

        return docuSignRequest;
    }

    getPreviousValues(): LayDcPlanFormModel {

        const previousValues = this.wizardOptions?.location?.state?.request?.values;

        if (previousValues) {
            return previousValues;
        }

        const defaultValues = this.getDefaultFormValues();
        return GetRsvpPreviousValues(this.wizardOptions?.rsvpPlanDetail, defaultValues);
    }
}